import { FormHelperText, Grid } from "@mui/material";
import AppDialog from "../../../components/Common/AppDialog";
import React, { useEffect, useRef, useState } from "react";
import Label from "../../../components/Common/Label";
import { Icon } from "@iconify/react/dist/iconify.js";
import CustomButton from "../../../components/Form/CustomButton";
import SearchBar from "../../../components/Common/Searchbar";
import Helpers from "../../../helpers/helpers";
import TablePageControl from "../../../components/Common/TablePageControl";
import ImportantNotice from "../../../components/Common/ImportantNotice";
import CustomYearRangePicker from "../../../components/Form/CustomYearRangePicker";
import { connect, useDispatch } from "react-redux";
import { getErpDetails, getErpListing, setErpDetailsLocal } from "../../../store/actions";
import PopoverFilter2 from "../../../components/Common/PopoverFilter2";
import moment from "moment";

const VehicleList = ({ formObj, handleFormChange, windowWidth, isDirectSeller, isSingPass, makeList, modelList, bodyList, erpListing, erpDetails, error, setIsLoading }) => {
    const dispatch = useDispatch();
    const [search, setSearch] = useState("");
    const [filterObject, setFilterObject] = useState({});
    const [detailOpen, setDetailOpen] = useState(false);
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [page, setPage] = useState(1);
    const [length, setLength] = useState(9);
    const searchRef = useRef(search);

    useEffect(() => {
        searchRef.current = search || '';
    }, [search]);

    useEffect(() => {
        initData();
    }, [page, length, filterObject]);

    const initData = () => {
        let payload = {
            page: page,
            length: length,
            search: searchRef.current,
            make: filterObject?.make || '',
            model: filterObject?.model || '',
            body: filterObject?.body_type || '',
            yearFrom: filterObject?.startYear || '',
            yearTo: filterObject?.endYear || '',
            inventoryType: formObj?.advert_type || '',
            token: getToken() || '',
        }
        dispatch(getErpListing(payload));
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                initData();
            }
        }, Helpers.searchInterval);
    }

    const resetFilter = () => {
        setFilterObject({});
        setSearch("");
    }

    const filteredModelList = () => {
        if (filterObject?.make) {
            return makeList?.find((item) => filterObject?.make?.includes(item?.id))?.models || modelList;
        }
        return modelList;
    }

    const filteredBodyList = () => {
        if (filterObject?.model) {
            return filteredModelList()?.find((item) => filterObject?.model?.includes(item?.id))?.bike_types || bodyList;
        }
        return bodyList;
    }

    const customToolsBar = () => {
        return (
            <Grid container spacing={2} mt={2} px={2}>
                <Grid container item lg={12} md={12} style={{ display: 'flex', alignItems: "center" }} spacing={1}>
                    <Grid item lg={12} md={12} xs={12} className="d-flex pb-1">
                        <SearchBar
                            value={search}
                            setValue={(e) => handleSearch(e)}
                            module={'registration no., make or model'}
                        />
                    </Grid>
                    <Grid item lg={2} md={3} sm={3} xs={6} className="mt-2">
                        <PopoverFilter2
                            module={'Make'}
                            placeholder={'Make'}
                            paddingInline={"5px"}
                            value={filterObject?.make || []}
                            notShowingModuleTitle={true}
                            filterData={[
                                {
                                    module: 'Make',
                                    list: makeList,
                                    valueName: 'id',
                                    labelName: 'name',
                                }]
                            }
                            setValue={(e) => setFilterObject((prevValues) => ({
                                ...prevValues,
                                make: e
                            }))}
                        />
                    </Grid>
                    <Grid item lg={2} md={3} sm={3} xs={6} className="mt-2">
                        <PopoverFilter2
                            module={'Model'}
                            placeholder={'Model'}
                            paddingInline={"5px"}
                            value={filterObject?.model || []}
                            notShowingModuleTitle={true}
                            filterData={[
                                {
                                    module: 'Model',
                                    list: filteredModelList(),
                                    valueName: 'id',
                                    labelName: 'name',
                                }]
                            }
                            setValue={(e) => setFilterObject((prevValues) => ({
                                ...prevValues,
                                model: e
                            }))}
                        />
                    </Grid>
                    <Grid item lg={2.2} md={3.5} sm={3.5} xs={6} className="mt-2">
                        <PopoverFilter2
                            module={'Body Type'}
                            placeholder={'Body Type'}
                            paddingInline={"5px"}
                            value={filterObject?.body_type || []}
                            notShowingModuleTitle={true}
                            filterData={[
                                {
                                    module: 'Body Type',
                                    list: filteredBodyList(),
                                    valueName: 'id',
                                    labelName: 'name',
                                }]
                            }
                            setValue={(e) => setFilterObject((prevValues) => ({
                                ...prevValues,
                                body_type: e
                            }))}
                        />
                    </Grid>
                    <Grid item lg={filterObject?.startYear && filterObject?.endYear ? 2 : 1.2} md={filterObject?.startYear && filterObject?.endYear ? 4 : 2} sm={filterObject?.startYear && filterObject?.endYear ? 4 : 2} xs={6} mt={1}>
                        <CustomYearRangePicker
                            startYear={filterObject?.startYear}
                            endYear={filterObject?.endYear}
                            setStartYear={(e) => setFilterObject((prevValues) => ({
                                ...prevValues,
                                startYear: e
                            }))}
                            setEndYear={(e) => setFilterObject((prevValues) => ({
                                ...prevValues,
                                endYear: e
                            }))}
                        />
                    </Grid>
                    <Grid item lg={2} md={3} xs={12} mt={1}>
                        <CustomButton
                            title={<div style={{ textDecorationLine: 'underline' }}>Clear all</div>}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#B48A3C'}
                            borderStyle={'none'}
                        />
                    </Grid>
                </Grid>

            </Grid>
        )
    }
    const getToken = () => {
        const searchParams = new URLSearchParams(window.location.search);
        const tokenFromUrl = searchParams.get('token');

        if (tokenFromUrl) {
            return tokenFromUrl;
        }

    }

    const renderVehicleList = (item, idx) => {
        const vehicleId = item?.id ?? idx;

        return (
            <Grid item lg={4} md={12} sm={12} xs={12} key={`vehicle-${idx}`}>
                <div className="dashboard-card p-3">
                    <div className="text-semibold font-size-16">{item?.make || '-'} {item?.model || ''}</div>
                    <div className="d-flex align-items-center mt-2">
                        {
                            Boolean(item?.manu_year) &&
                            <Label.CustomLabel
                                label={item?.manu_year}
                                color={'#808588'}
                                backgroundColor={'#F5F5F5'}
                                border={"1px solid #F5F5F5"}
                                borderRadius={6}
                            />
                        }
                        {
                            (Boolean(item?.engine_cc) || Boolean(item?.engine_cap)) &&
                            <Label.CustomLabel
                                label={item?.engine_cc || item?.engine_cap}
                                color={'#808588'}
                                backgroundColor={'#F5F5F5'}
                                border={"1px solid #F5F5F5"}
                                borderRadius={6}
                                marginLeft={Boolean(item?.manu_year) ? 10 : 0}
                            />
                        }
                    </div>
                    <div className="my-3 mb-4">
                        <div className="subheader-3">Reg No.</div>
                        <div>{item?.reg_no || '-'}</div>
                        {!isSingPass ?
                            <>
                                <div className="subheader-3 mt-1">Stock ID</div>
                                <div>{item?.stock_id || '-'}</div>
                                <div className="subheader-3 mt-1">Body Type</div>
                                <div>{item?.body_type || '-'}</div>
                            </> :
                            <>
                                <div className="subheader-3 mt-1">COE Expiry Date</div>
                                <div>{item?.coe_expiry || '-'}</div>
                                <div className="subheader-3 mt-1">No. of Owner(s)</div>
                                <div>{item?.no_of_owner || '-'}</div>
                            </>
                        }

                    </div>
                    <div className="mb-3">
                        <CustomButton
                            title={(formObj?.vehicle?.id ?? formObj?.selected_vehicle_id) === vehicleId ? 'Selected' : 'Select This Unit'}
                            press={() => { handleFormChange('selected_vehicle_id', vehicleId); dispatch(setErpDetailsLocal({ data: item })) }}
                            width={'100%'}
                            backgroundColor={(formObj?.vehicle?.id ?? formObj?.selected_vehicle_id) === vehicleId ? '#1D1B1B' : '#F5F5F5'}
                            textColor={(formObj?.vehicle?.id ?? formObj?.selected_vehicle_id) === vehicleId ? '#FFFFFF' : '#1D1B1B'}
                            padding={20}
                        />
                    </div>
                    <div>
                        <CustomButton
                            title={<div className="d-flex align-items-center">View details <Icon icon={'fluent:chevron-right-20-regular'} style={{ marginLeft: 5, height: 16 }} /></div>}
                            press={() => {
                                // after select and get details response, just open the modal
                                if (erpDetails?.id) {
                                    if (erpDetails?.id == formObj?.selected_vehicle_id && formObj?.selected_vehicle_id == item?.id) {
                                        setDetailOpen(true);
                                        return;
                                    }
                                    // if opened other vehicle details, and click back the selected vehicle, set indicator and call again details api
                                    if ((erpDetails?.id != formObj?.selected_vehicle_id) || (formObj?.selected_vehicle_id !== item?.id)) {
                                        handleFormChange('open_selected_vehicle', true);
                                    }
                                    if (erpDetails?.id) {
                                        dispatch(getErpDetails({ id: item?.id }));
                                        setIsLoading(true);
                                    }
                                }
                                else {
                                    dispatch(setErpDetailsLocal({ data: item }))
                                    setDetailOpen(true);
                                }
                            }}
                            width={'100%'}
                            backgroundColor={'transparent'}
                            textColor={'#B48A3C'}
                            borderStyle={'none'}
                            padding={20}
                        />
                    </div>
                </div>
            </Grid>
        )
    }

    return (
        <React.Fragment>
            <Grid container spacing={2}>
                {!isDirectSeller && customToolsBar()}
                {
                    error?.erp_id &&
                    <Grid item sm={12}>
                        <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.erp_id || ""}</FormHelperText>
                    </Grid>
                }
                {!isDirectSeller && <Grid item sm={12} className="subheader-3">Select one (1) unit from your Inventory to create this advert</Grid>}
                {
                    isDirectSeller &&
                    <Grid item sm={12}>
                        <ImportantNotice
                            iconName={'ri:check-line'}
                            iconColor={'#11812E'}
                            color={'#11812E'}
                            textColor={'#11812E'}
                            backgroundColor={'#34C75926'}
                            message={
                                <>
                                    <div className="text-bold">MyInfo verification complete.</div>
                                    <div className="mt-2">We’ve retrieved your vehicle details from LTA.</div>
                                </>
                            }
                        />
                    </Grid>
                }
                <Grid item container lg={12} md={12} sm={12} spacing={2}>
                    {
                        erpListing?.data?.length > 0 ?
                            erpListing?.data?.map((item, idx) => renderVehicleList(item, idx))
                            : <Grid item sm={12} xs={12} className="d-flex align-items-center justify-content-center" style={{ color: '#999999', minHeight: 200 }}>Nothing here yet</Grid>
                    }
                </Grid>
                <Grid item lg={12} md={12} sm={12} className="d-flex justify-content-center" style={{ textAlign: 'center' }}>
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={erpListing?.last_page || 1}
                        justifyContent="center"
                    />
                </Grid>
            </Grid>
            <AppDialog
                open={detailOpen}
                close={() => setDetailOpen(false)}
                vehicleData={erpDetails}
                title={`${erpDetails?.make} ${erpDetails?.model} ${erpDetails?.manu_year ? `(${erpDetails?.manu_year})` : ''}`}
                positiveTitle={'Close'}
                positivePress={() => setDetailOpen(false)}
                width={'45%'}
                isMobile={windowWidth <= 768 ? true : false}
            >
                <Grid container spacing={2}>
                    <Grid item lg={6} md={5} sm={12} xs={12} className="subheader-3">Make / Model</Grid>
                    <Grid item lg={6} md={7} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {erpDetails?.make} / {erpDetails?.model}
                    </Grid>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Registration Number</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {erpDetails?.reg_no || '-'}
                    </Grid>
                    {!isSingPass && (
                        <>
                            <Grid item md={6} sm={12} xs={12} className="subheader-3">Stock ID</Grid>
                            <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                                {erpDetails?.stock_id || '-'}
                            </Grid>
                            <Grid item md={6} sm={12} xs={12} className="subheader-3">Body Type</Grid>
                            <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                                {erpDetails?.body_type || '-'}
                            </Grid>
                        </>
                    )}

                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Primary Colour</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {erpDetails?.color || erpDetails?.colour || '-'}
                    </Grid>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Year of Manufacture</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {erpDetails?.manu_year || '-'}
                    </Grid>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Registration Date</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {erpDetails?.reg_date ? moment(erpDetails?.reg_date, "YYYY-MM-DD").format('DD-MM-YYYY') : erpDetails?.first_reg_date ? moment(erpDetails?.first_reg_date, "YYYY-MM-DD").format('DD MMM YYYY') : '-'}
                    </Grid>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Engine Capacity (CC)</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {erpDetails?.engine_cc || erpDetails?.engine_cap || '-'}
                    </Grid>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">COE Category</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {erpDetails?.coe_category || '-'}
                    </Grid>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">COE Expiry Date</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {erpDetails?.coe_expiry ? moment(erpDetails?.coe_expiry, "YYYY-MM-DD").format('DD-MM-YYYY') : '-'}
                    </Grid>
                    {!isSingPass &&
                        <>
                            <Grid item md={6} sm={12} xs={12} className="subheader-3">Revision Count</Grid>
                            <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                                {erpDetails?.revision || '0'}
                            </Grid>
                        </>}
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Number of Previous Owner</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {erpDetails?.no_of_owner || '0'}
                    </Grid>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Mileage (KM)</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {erpDetails?.mileage || '-'}
                    </Grid>
                    {
                        !isSingPass &&
                        <>
                            <Grid item md={6} sm={12} xs={12} className="subheader-3">Stock Status</Grid>
                            <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                                {erpDetails?.stock_status || '-'}
                            </Grid>
                            <Grid item md={6} sm={12} xs={12} className="subheader-3">Purchase Cost ($)</Grid>
                            <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                                {erpDetails?.purchase_price ? Number(erpDetails?.purchase_price)?.toFixed(2) || '0.00' : '0.00'}
                            </Grid>
                            <Grid item md={6} sm={12} xs={12} className="subheader-3">Recommended Selling Price ($)</Grid>
                            <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                                {erpDetails?.suggested_price ? Number(erpDetails?.suggested_price)?.toFixed(2) || '0.00' : '0.00'}
                            </Grid>
                            <Grid item md={6} sm={12} xs={12} className="subheader-3">ARF ($)</Grid>
                            <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                                {erpDetails?.arf ? Number(erpDetails?.arf)?.toFixed(2) || '0.00' : '0.00'}
                            </Grid>
                            <Grid item md={6} sm={12} xs={12} className="subheader-3">Internal Remarks</Grid>
                            <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                                {erpDetails?.internal_remarks || '-'}
                            </Grid>
                        </>
                    }

                    {/* <Grid item md={6} sm={12} xs={12} className="subheader-3">Vehicle Source</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {erpDetails?.source || '-'}
                    </Grid>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Propellant Type</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {erpDetails?.propellant_type || '-'}
                    </Grid>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Chassis Number</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                        {erpDetails?.chassis_number || '-'}
                    </Grid> */}
                </Grid>
            </AppDialog>
        </React.Fragment>
    )
}


function mapStateToProps({ Advert, General }) {
    return {
        makeList: General.bike_makes,
        modelList: General.bike_models,
        bodyList: General.bike_types,
        erpListing: Advert.erpListing?.data || [],
        erpDetails: Advert.erpDetails?.data || null,
    };
}


export default connect(mapStateToProps)(VehicleList);